<template>
    <div class="editform">
        <Form
            ref="dsInfo"
            :model="dsInfo"
            :rules="ruleValidate"
            :label-width="90"
        >
            <FormItem label="词典名称" prop="name">
                <Input
                    v-model="dsInfo.name"
                    placeholder=""
                    :maxlength="32"
                ></Input>
            </FormItem>
            <FormItem label="词典代码" prop="code">
                <Input
                    v-model="dsInfo.code"
                    placeholder=""
                    :maxlength="32"
                ></Input>
            </FormItem>
            <FormItem label="是否系统内置" prop="sys">
                <Select v-model="dsInfo.sys" transfer>
                    <Option
                        v-for="(item, index) in sysList"
                        :value="item.id"
                        :key="index"
                        >{{ item.text }}</Option
                    >
                </Select>
            </FormItem>
            <FormItem label="备注" prop="sys">
                <Input
                    v-model="dsInfo.remark"
                    type="textarea"
                    :rows="3"
                    :maxlength="1000"
                ></Input>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import { dictUpdate, dictView } from '@/api/sys-dict'
import Enum from '_u/enum'

const syss = Enum.get('YN')

export default {
    name: 'dictSonForm',

    props: {
        pid: {
            type: [String, Number],
            default: '',
        },
        id: {
            type: [String, Number],
            default: '',
        },
        ver: {
            type: [String, Number],
            default: '',
        },
        prodId: {
            type: [String, Number],
            default: '',
        },
    },

    components: {},

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            dsInfo: {
                id: '',
                name: '',
                code: '',
                pid: '',
                ver: '',
                sys: syss.no,
                remark: '',
            },
            syss,
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: '词典名称必填',
                        trigger: 'blur',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: '词典代码必填',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },

    computed: {
        sysList: function () {
            return syss.toList()
        },
    },

    methods: {
        fetch() {
            return dictView(this.id).then((res) => {
                var resData = res.data

                Object.keys(this.dsInfo).forEach(
                    (k) => (this.dsInfo[k] = resData[k])
                )
            })
        },
    },

    mounted() {
        this.dsInfo.pid = this.pid
        this.dsInfo.id = this.id
        this.dsInfo.ver = this.ver
        var $dsInfo = this.$refs.dsInfo

        this.$modal.onBtnClick('confirm', (next, options) => {
            $dsInfo.validate((valid) => {
                if (valid) {
                    this.dsInfo.prodId = this.prodId
                    dictUpdate(this.dsInfo)
                        .then(
                            (res) =>
                                this.$Message.success(
                                    this.$t('tips.update.success')
                                ),
                            (err) => (options.closeModal = false)
                        )
                        .then((res) => next())
                } else {
                    options.closeModal = false
                    next()
                }
            })
        })

        // 在窗口显示前加载数据
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch()]).then((args) => {
                next()
            })
        })
    },
}
</script>
